export default __webpack_public_path__ + "static/media/Mark-2-Suit-01.5a9177c9.jpg";